document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('[id^="ps-section-"]').forEach(section => {

    /* WISHLIST */

    section.querySelectorAll('.ps-wishlist').forEach(btn => {

      btn.addEventListener('click', function () {

        btn.classList.toggle('active');

        btn.innerHTML = btn.classList.contains('active') ? '♥' : '♡';

      });

    });

    /* POPUP OPEN */

    section.querySelectorAll('.ps-quick-btn').forEach(btn => {

      btn.addEventListener('click', function () {

        const popup = document.getElementById(btn.dataset.popup);

        if (popup) {
          popup.classList.add('active');
          document.body.style.overflow = 'hidden';
        }

      });

    });

    /* POPUP CLOSE BUTTON */

    section.querySelectorAll('.ps-popup-close').forEach(btn => {

      btn.addEventListener('click', function () {

        const popup = btn.closest('.ps-popup');

        popup.classList.remove('active');

        document.body.style.overflow = '';

      });

    });

    /* POPUP OVERLAY CLOSE */

    section.querySelectorAll('.ps-popup-overlay').forEach(overlay => {

      overlay.addEventListener('click', function () {

        const popup = overlay.closest('.ps-popup');

        popup.classList.remove('active');

        document.body.style.overflow = '';

      });

    });

    /* ESC CLOSE */

    document.addEventListener('keydown', function (e) {

      if (e.key === 'Escape') {

        section.querySelectorAll('.ps-popup.active').forEach(popup => {

          popup.classList.remove('active');

          document.body.style.overflow = '';

        });

      }

    });

    /* VARIANT + QUANTITY */

    section.querySelectorAll('.ps-popup').forEach(popup => {

      const variantSelect = popup.querySelector('.ps-variant');

      const hiddenVariant = popup.querySelector('.ps-hidden-variant-id');

      const qtyInput = popup.querySelector('.ps-qty-input');

      const hiddenQty = popup.querySelector('.ps-hidden-qty');

      const plusBtn = popup.querySelector('.ps-plus');

      const minusBtn = popup.querySelector('.ps-minus');

      /* VARIANT */

      if (variantSelect && hiddenVariant) {

        hiddenVariant.value = variantSelect.value;

        variantSelect.addEventListener('change', function () {

          hiddenVariant.value = this.value;

        });

      }

      /* QUANTITY INIT */

      if (hiddenQty && qtyInput) {

        hiddenQty.value = qtyInput.value;

      }

      /* PLUS */

      plusBtn?.addEventListener('click', function () {

        let qty = parseInt(qtyInput.value);

        qty++;

        qtyInput.value = qty;

        hiddenQty.value = qty;

      });

      /* MINUS */

      minusBtn?.addEventListener('click', function () {

        let qty = parseInt(qtyInput.value);

        if (qty > 1) {

          qty--;

          qtyInput.value = qty;

          hiddenQty.value = qty;

        }

      });

      /* INPUT CHANGE */

      qtyInput?.addEventListener('change', function () {

        let qty = parseInt(this.value);

        if (isNaN(qty) || qty < 1) {
          qty = 1;
        }

        this.value = qty;

        hiddenQty.value = qty;

      });

    });

    /* SLIDER */

    section.querySelectorAll('.ps-products-wrapper').forEach(wrapper => {

      const slider = wrapper.querySelector('.ps-products-grid');

      const nextBtn = wrapper.querySelector('.ps-slider-next');

      const prevBtn = wrapper.querySelector('.ps-slider-prev');

      if (!slider || !nextBtn || !prevBtn) return;

      const getScrollAmount = () => {

        const card = slider.querySelector('.ps-product-card');

        return card ? card.offsetWidth + 24 : 400;

      };

      /* NEXT */

      nextBtn.addEventListener('click', function () {

        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });

      });

      /* PREV */

      prevBtn.addEventListener('click', function () {

        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });

      });

    });

  });

});